<script lang="ts">
	// Main tab content for IR_REM-1-remote
</script>

<div class="main-content">
	<h3>Main Content for IR_REM-1-remote</h3>
	<p>This is the main tab content for the IR_REM-1-remote device.</p>
	<!-- Add your specific main content here -->
</div>

<style>
	.main-content {
		padding: 1rem;
	}
</style>
